import { END_POINTS } from "../constants/url";
import { Category, CategoryBody } from "../types/General";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};

export const categoryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query<
      CommonResponseType & {
        data: { list: Category[]; totalCount: number; totalPages: number };
      },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.category}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),
    addCategory: builder.mutation<
      CommonResponseType & { data: Category },
      { categoryName: string }
    >({
      query: (body) => ({
        url: END_POINTS.category,
        method: "POST",
        body,
      }),
    }),
    updateStatus: builder.mutation<
      CommonResponseType & { data: Category },
      {
        isBlocked: boolean;
        categoryId: string;
      }
    >({
      query: (body) => ({
        url: `${END_POINTS.category}`,
        method: "PUT",
        body,
      }),
    }),

    updateCategory: builder.mutation<
      CommonResponseType & { data: Category },
      CategoryBody
    >({
      query: (body) => ({
        url: `${END_POINTS.category}`,
        method: "PUT",
        body,
      }),
    }),

    getCategoryById: builder.query<
      CommonResponseType & { data: Category },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "GET",
      }),
    }),
    deleteCategory: builder.query<CommonResponseType, { categoryId: string }>({
      query: (body) => ({
        url: `${END_POINTS.category}`,
        method: "DELETE",
        body,
      }),
    }),
  }),
});
export const {
  useLazyGetCategoryQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useLazyGetCategoryByIdQuery,
  useLazyDeleteCategoryQuery,
  useUpdateStatusMutation,
} = categoryApi;
